import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=8d9a771a&scoped=true"
import script from "./uploader.vue?vue&type=script&lang=ts"
export * from "./uploader.vue?vue&type=script&lang=ts"
import style0 from "./uploader.vue?vue&type=style&index=0&id=8d9a771a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9a771a",
  null
  
)

export default component.exports